import { adSources } from './adSources';

const BID_TIMEOUT = 2000;

const fetchWithTimeout = (fetchPromise, timeout) => {
    return Promise.race([
        fetchPromise,
        new Promise((resolve, reject) => setTimeout(() => reject(new Error('Timeout')), timeout))
    ]);
};

const fetchAdBids = async (params, sourceKey) => {
    const sourceConfig = adSources[sourceKey];
    if (!sourceConfig) {
        console.error(`Ad source "${sourceKey}" not found`);
        return;
    }

    if (sourceConfig.type === 'callback') {
        // Handle callback-based sources (like APS)
        return fetchWithTimeout(
            new Promise((resolve) => {
                window.apstag.fetchBids(
                    {
                        slots: params.slots,
                        timeout: BID_TIMEOUT
                    },
                    (bids) => resolve(bids)
                );
            }),
            BID_TIMEOUT
        ).catch((error) => {
            console.error(`Error fetching bids from ${sourceKey}:`, error);
            return [];
        });
    }

    // Default HTTP fetch for other sources
    const queryString = new URLSearchParams(params).toString();
    const url = sourceConfig.method === 'GET' ? `${sourceConfig.url}?${queryString}` : sourceConfig.url;

    const fetchPromise = fetch(url, {
        method: sourceConfig.method,
        headers: sourceConfig.headers,
        body: sourceConfig.method === 'POST' ? JSON.stringify(params) : undefined
    });

    return fetchWithTimeout(fetchPromise, BID_TIMEOUT)
        .then((response) => (response.ok ? response.json() : Promise.reject(response.statusText)))
        .catch((error) => {
            console.error(`Error fetching bids from ${sourceKey}:`, error);
            return {};
        });
};

export default fetchAdBids;
